export const HeartSecurityIcon = () => (
  <svg
    className="security-icon"
    width="28"
    height="28"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 21C12 21 4 16 4 9.5C4 6.46 6.46 4 9.5 4C11.24 4 12 5.2 12 5.2C12 5.2 12.76 4 14.5 4C17.54 4 20 6.46 20 9.5C20 16 12 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V13"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M9.5 10.5H14.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
